<template>
  <div class="hot-rank-wrapper" >
    <Table v-bind="table"  height="100%"></Table>
  </div>
</template>

<script>
import { getHoList } from '@/api/workBench'
import Table from '@/components/page/Table.vue'
export default{
  components: {
    Table
  },
  props: {

  },
  data () {
    return {
      table: {
        selection: false, // 是否开启选择框
        hiddenOperate: true,
        tableInfo: [{
          key: 'name',
          name: '名称'
        }, {
          key: 'coverImageUrl',
          name: '图片',
          type: 'img'
        }, {
          key: 'pvCount',
          name: '浏览量'
        }, {
          key: 'likeCount',
          name: '点赞量'
        }, {
          key: 'registrationCount',
          name: '报名量'
        }, {
          key: 'joinCount',
          name: '参与量'
        }],
        tableData: []
      }
    }
  },
  computed: {

  },
  mounted () {
    this.getHoListRank()
  },
  methods: {
    getHoListRank () {
      getHoList({size: 10, current: 1}).then(({success, data}) => {
        if (success) {
          this.$set(this.table, 'tableData', data)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hot-rank-wrapper{
  width: 100%;
  height: 100%;
  font-size: 14px;
}
::v-deep .el-table__fixed-right {
  right: 0 !important;
  // bottom: 0 !important;
}
::v-deep .el-table__body-wrapper {
  &::-webkit-scrollbar {
    // 整个滚动条
    width: 0; // 纵向滚动条的宽度
    background: rgba(213, 215, 220, 0.3);
    border: none;
  }
  &::-webkit-scrollbar-track {
    // 滚动条轨道
    border: none;
  }
}

// --------------------隐藏table gutter列和内容区右侧的空白 start
::v-deep .el-table th.gutter {
  display: none;
  width: 0;
}
::v-deep .el-table colgroup col[name="gutter"] {
  display: none;
  width: 0;
}

::v-deep .el-table__body {
  width: 100% !important;
}

</style>